<template>
    <div class="airQuality">
        <div class="airTitle">{{title}}</div>
        <div class="content">
            <div class="item" v-for="(value, key) in dataObj" :key="key">
                <div class="propName">{{key}}</div>
                <div class="value">{{value}}</div>
            </div>
        </div>
        <div class="institution">{{institution}}</div>
    </div>
</template>

<script>
import { home } from '../../api/index'
export default {
    created() {
        home.getGZ_airQuality().then(data => {
            this.dataObj = {
               'AQI': data.aqi,
               '空气质量级别': data.aqi_level,
               '首要污染物': data.primary_p,
               'PM2.5平均值': data.pm25 + 'μg/m³'
            };
            this.publishTime = data.ftime;
            this.institution = '广州市环境监测中心和' +data.content.split('、')[1].slice(0,6) + '联合发布';
        })
    },
    data() {
        return {
            publishTime: '',
            dataObj: {},
            institution: '',
        }
    },
    computed: {
        title() {
            return '广州市空气质量预报(' + this.publishTime + ')'
        }
    }
}
</script>

<style lang="less">
    .airQuality {
        .airTitle,
        .institution {
            height: 40px;
            font-size: 14px;
            color: #756C5E;
            line-height: 40px;
            text-align: center;
        }
        .content {
            display: flex;
            flex-wrap: wrap;
            padding: 5px;
            .item {
                display: flex;
                flex-direction: column;
                align-items: center;
                width: 158px;
                height: 70px;
                border: 1px solid #E9D7BE;
                border-left: none;
                .propName,
                .value {
                    width: 100%;
                    height: 50%;
                    line-height: 35px;
                    text-align: center;
                }
            }
            .item:nth-of-type(even) {
                border-right: none;
            }
            .item:nth-of-type(1),
            .item:nth-of-type(2) {
                border-bottom: none
            }
        }
    }
</style>